import handler from 'api/handler'

const prefix = '/userAdmin/matrimonial/fetchAll'

const methods = {
    getMatrimonialProfiles: args => handler({ method: 'get', url: prefix, params: args }),
}

export default methods
